module.exports = __webpack_public_path__ + "static/media/(000072).2bcfeaf7.jpg";